var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext, useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import { ComponentThemeProvider } from '../../ThemeProvider';
import componentTheme from '../theme';
export var defaultConfig = {
    cardIdentifier: 'card-installment-calculator',
    isCardLayout: false,
    isExtendedLabel: false,
    isLargeLinkText: false,
    isSmallPrize: false,
};
export var InstallmentCalculatorContext = createContext({
    config: defaultConfig,
    error: undefined,
    installmentPrice: 0,
    installmentRequestSource: '',
    isLoading: true,
    isPaymentPause: false,
    isPriceEditable: false,
    numberOfInstallments: 0,
    response: undefined,
    setInstallmentPrice: function () { },
    setInstallmentRequestSource: function () { },
    setIsPaymentPause: function () { },
    setIsPriceEditable: function () { },
    setNumberOfInstallments: function () { },
});
export var useInstallmentCalculatorContext = function () {
    return useContext(InstallmentCalculatorContext);
};
export var InstallmentCalculatorContextProvider = function (_a) {
    var fixedPrice = _a.fixedPrice, _b = _a.installments, initialInstallments = _b === void 0 ? 0 : _b, _c = _a.selectionCallback, selectionCallback = _c === void 0 ? function () { } : _c, children = _a.children, props = __rest(_a, ["fixedPrice", "installments", "selectionCallback", "children"]);
    var _d = useState(initialInstallments), installments = _d[0], setInstallments = _d[1];
    var _e = useState(false), paymentPause = _e[0], setPaymentPause = _e[1];
    var _f = useState(0), price = _f[0], setPrice = _f[1];
    var _g = useState(false), priceEditable = _g[0], setPriceEditable = _g[1];
    var _h = useState(''), requestSource = _h[0], setRequestSource = _h[1];
    useEffect(function () {
        if (fixedPrice)
            setPrice(fixedPrice);
    }, [fixedPrice]);
    var apiEndpointUrl = '/api/inform/installment';
    var fetchConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'POST',
    };
    var body = {
        basevalue: (price || 0) / 100,
        source: requestSource,
        paymentpause: paymentPause,
    };
    if (installments && installments > 0) {
        body = __assign(__assign({}, body), { selectedNumberOfInstallments: installments });
    }
    var _j = useFetch({
        body: body,
        fetchConfig: fetchConfig,
        url: apiEndpointUrl,
    }), response = _j.response, error = _j.error, isLoading = _j.isLoading;
    useEffect(function () {
        if (response === null || response === void 0 ? void 0 : response.numberOfInstallments)
            setInstallments(response === null || response === void 0 ? void 0 : response.numberOfInstallments);
    }, [response === null || response === void 0 ? void 0 : response.numberOfInstallments]);
    useEffect(function () {
        selectionCallback(installments, paymentPause);
    }, [installments, paymentPause]);
    return (React.createElement(ComponentThemeProvider, { theme: componentTheme },
        React.createElement(InstallmentCalculatorContext.Provider, __assign({ value: {
                config: defaultConfig,
                error: error,
                installmentPrice: price,
                installmentRequestSource: requestSource,
                isLoading: isLoading,
                isPaymentPause: paymentPause,
                isPriceEditable: priceEditable,
                numberOfInstallments: installments,
                response: response,
                setInstallmentPrice: function (value) { return setPrice(value); },
                setInstallmentRequestSource: function (src) { return setRequestSource(src); },
                setIsPaymentPause: function (flag) { return setPaymentPause(flag); },
                setIsPriceEditable: function (isEditable) { return setPriceEditable(isEditable); },
                setNumberOfInstallments: function (value) { return setInstallments(value); },
            } }, props), children)));
};
export default InstallmentCalculatorContextProvider;
//# sourceMappingURL=index.js.map